import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { ExperienceEvent } from '@atlassian/experience-tracker';
import {
	fireTrackAnalytics,
	fireUIAnalytics,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import type { RouterActionsType } from '@atlassian/react-resource-router';

type ExperienceTrackerParams = {
	payload: ExperienceEvent;
	projectKey: string | undefined;
	pageId: string;
	routerActions: RouterActionsType;
	analyticsEvent: UIAnalyticsEvent;
	deleteSuccessCallback: (articleId: string) => Promise<void>;
	viewSuccessCallback: () => void;
	onViewPageLoadFailure: () => void;
};

export const DELETE_PAGE = 'delete-page';
export const VIEW_PAGE = 'view-page';

export const experienceTrackerCallback = (params: ExperienceTrackerParams) => {
	const {
		payload,
		projectKey,
		pageId,
		routerActions,
		analyticsEvent,
		deleteSuccessCallback,
		viewSuccessCallback,
		onViewPageLoadFailure,
	} = params;
	const { action, name, attributes } = payload;

	switch (action) {
		case 'taskStart':
			// @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
			if (name === DELETE_PAGE && attributes?.contentId === pageId) {
				fireUIAnalytics(analyticsEvent, 'deleteButton clicked', {
					articleId: pageId,
				});
			}
			break;
		case 'taskSuccess':
			if (
				name === DELETE_PAGE &&
				// @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
				attributes?.contentId === pageId &&
				projectKey !== undefined
			) {
				fireTrackAnalytics(analyticsEvent, 'onArticleDelete success', {
					articleId: pageId,
				});
				deleteSuccessCallback(pageId);
				routerActions.push(`/jira/servicedesk/projects/${projectKey}/knowledge/articles`);
			}

			// @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
			if (name === VIEW_PAGE && attributes?.contentId === pageId) {
				viewSuccessCallback();
				fireTrackAnalytics(analyticsEvent, 'epViewPage success', {
					articleId: pageId,
				});
			}
			break;
		case 'taskFail':
			// @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
			if (name === DELETE_PAGE && attributes?.contentId === pageId) {
				fireOperationalAnalytics(analyticsEvent, 'onArticleDelete failure', {
					articleId: pageId,
				});
			}
			// @ts-expect-error - TS2339 - Property 'contentId' does not exist on type 'object'.
			if (name === VIEW_PAGE && attributes?.contentId === pageId) {
				fireOperationalAnalytics(analyticsEvent, 'epViewPage failure', {
					articleId: pageId,
				});
				onViewPageLoadFailure();
			}
			break;
		default:
			break;
	}
};
